import React from "react";
import { dialog, Button, InputFactory } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class FamilyPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      name: "",
      birthDate: "",
      obj: "",
      objects: [],
      initialData: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.name)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.name)
      );
      if (newObjects.length > 0) {
        console.warn("NEWLY INPUT DATA: ", newObjects);
        localStorage.setItem("Children", JSON.stringify(newObjects));
      }
    }
  }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const { obj } = this.state;
    const newObject = await findObjectUseCase().execute("family_background", {
      where: { empID: this.props.object.id },
    });
    this.setState({
      initialData: newObject,
      name: obj.name,
      birthDate: obj.birth,
    });
  }

  getCollectionName() {
    return "family_background";
  }

  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute("family_background", {
    //   where: { id: id },
    // });
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeletedChildren")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeletedChildren", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute("family_background", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, "family_background", () => this.refetchData());
  }

  handleObjectData(data) {
    this.handleAddChildren(data);
  }

  handleSaveButton = async (obj) => {
    if (obj) {
      const data = {
        name: this.state.name,
        empID: this.props.object.id,
        birth: this.state.birthDate,
        email: this.props.object.email,
        id: obj.id,
      };
      await this.presenter.upsertUseCase.execute("family_background", data);
      dialog.close();
      this.refetchData();
      this.refetchData();
    } else {
      const data = {
        name: this.state.name,
        empID: this.props.object.id,
        birth: this.state.birthDate,
        email: this.props.object.email,
      };
      await this.presenter.upsertUseCase.execute("family_background", data);
      dialog.close();
      this.refetchData();
      this.refetchData();
    }
  };

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onchangeName(name) {
    this.setState({ name });
  }

  onchangeBirthDate(birthDate) {
    this.setState({ birthDate });
  }

  handleAddChildren(data) {
    // const object = this.state.objects;
    this.setState({ obj: data });
    dialog.fire({
      html: (
        <div className="p-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSaveButton(data);
            }}
          >
            <h4>Add Children</h4>
            <hr />
            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              required
              type="String"
              field="name"
              defaultValue={data.name}
              onChange={this.onchangeName.bind(this)}
            />
            <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
              Date of Birth (mm/dd/yyyy) <span style={{ color: "red" }}>*</span>
            </label>
            <InputFactory
              required
              type="Date"
              field="birth"
              object={data}
              onChange={this.onchangeBirthDate.bind(this)}
            />

            <div className="mt-4 mb-4 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-light fs-sm me-3"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                // onClick={() => this.handleSaveButton(data)}
                type="submit"
                className="btn btn-primary fs-sm me-3"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      ),
      footer: false,
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.handleAddChildren.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Children
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default FamilyPage;
